import React from 'react';
import './TaskCard.css';
import { TaskProgress } from '../../types';

interface TaskCardProps {
  taskProgress: TaskProgress;
  onComplete?: (taskId: number) => void;
  onClaimReward?: (taskId: number) => void;
}

const TaskCard: React.FC<TaskCardProps> = ({ taskProgress, onComplete, onClaimReward }) => {
  const { task, userTask, canClaim, isCompleted, progress, isExpired } = taskProgress;

  const getTaskTypeIcon = (type: string) => {
    switch (type) {
      case 'one_time':
        return '⭐';
      case 'daily':
        return '📅';
      case 'time_limited':
        return '⏰';
      default:
        return '📋';
    }
  };

  const getCategoryIcon = (category: string) => {
    switch (category) {
      case 'profile_update':
        return '👤';
      case 'phone_verification':
        return '📱';
      case 'social_interaction':
        return '🌐';
      case 'mini_quiz':
        return '🧠';
      case 'kiloba_9_floors':
        return '🏢';
      case 'kiloba_racing':
        return '🏎️';
      default:
        return '📋';
    }
  };

  const getStatusText = () => {
    if (isExpired) return 'Đã hết hạn';
    if (userTask?.status === 'failed') return 'Thất bại';
    if (userTask?.status === 'claimed') return 'Đã nhận thưởng';
    if (canClaim) return 'Có thể nhận thưởng';
    if (isCompleted) return 'Đã hoàn thành';
    if (userTask?.status === 'in_progress') return 'Đang thực hiện';
    return 'Chưa bắt đầu';
  };

  const getStatusClass = () => {
    if (isExpired) return 'expired';
    if (userTask?.status === 'failed') return 'failed';
    if (userTask?.status === 'claimed') return 'claimed';
    if (canClaim) return 'can-claim';
    if (isCompleted) return 'completed';
    if (userTask?.status === 'in_progress') return 'in-progress';
    return 'not-started';
  };

  const handleActionClick = () => {
    if (canClaim && onClaimReward) {
      onClaimReward(task.id);
    } else if (!isCompleted && !isExpired && userTask?.status !== 'failed' && onComplete) {
      onComplete(task.id);
    }
  };

  const formatDate = (dateString?: string) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('vi-VN');
  };

  return (
    <div className={`task-card ${getStatusClass()}`}>
      <div className="task-detail">
        <div className="task-avatar">
          <img style={{width: 50}} src={`/images/tasks/${task.category}.png`} alt={task.category} />
        </div>
        <div className="task-info">
          <p className="task-description">{task.description}</p>
        </div>
      </div>

      <div className="task__action-bar">
        <div 
          onClick={handleActionClick}
          className={`task__reward ${canClaim ? 'task-card-can-claim' : ''}`}>
            <span className="task__reward-label">Nhận thưởng</span>
            <div className="task__energy-icon">
              <img 
                src="/images/energy-icon.svg" 
                alt="Energy"
                className="task__energy-icon"
              />
            </div>
            <span className="task__reward-amount">x {task.rewardEnergy}</span>
        </div>


        <button 
          className={`task-action-btn`}
          onClick={handleActionClick}
          disabled={isCompleted || userTask?.status === 'failed'}
        >
          Thực hiện
        </button>
      </div>
    </div>
  );
};

export default TaskCard;
